/**
 * BridgePlaceholder — Phase 3 will build the full Bridge DB connector view.
 */
import { Database } from 'lucide-react';

export default function BridgePlaceholder() {
  return (
    <div data-testid="tab-bridge" className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-ivory mb-1">Bridge Database</h1>
        <p className="text-gray-400">Live connector to the app.kgob.com CRM. Detailed view coming in Phase 3.</p>
      </div>
      <div className="bg-navy-light rounded-2xl border border-gray-700/50 p-8 text-center">
        <Database className="w-10 h-10 mx-auto mb-4 text-[#11a0c2]" />
        <h2 className="text-xl font-bold text-ivory mb-2">Bridge DB tab is reserved</h2>
        <p className="text-gray-400 max-w-md mx-auto">
          Bridge status (latency, throughput, queue) currently lives inside the CRM Sync tab. A dedicated view will surface here during Phase 3.
        </p>
      </div>
    </div>
  );
}
